module.exports = __webpack_public_path__ + "static/media/galerija_2014 (2).3bd3f087.jpg";